<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="container mb-5">
  <h4>Components Test Page</h4>
  <hr/>


  <div class="row">
    <div class="col">
      <div class="mt-2">
      <label>Will Search for Users</label>
      <input-search
        [items]="users"
        [provider]="userProvider"
        placeholder="Search User"
        (valueChange)="processPresetValue($event)"></input-search>
    </div>

    <div class="mt-2">
      <label>Will Search for Clients</label>
      <input-search
        [items]="clients"
        [showCreate]="true"
        [createNew]="typesOfData.CLIENT"
        [provider]="clientProvider"
        [(ngModel)]="selClientTest"
        [required]="true"
        name="clientSearch"
        (valueChange)="processPresetValue($event)"></input-search>
    </div>

    <div class="mt-2">
      <label>Will Search for Client Users (From Client above)</label>
      <!-- Will Search for Clients-->
      <input-search
        [items]="clientUsers"
        [showCreate]="true"
        [createNew]="typesOfData.CLIENT_USER"
        [provider]="clientUserProvider"
        [required]="true"
        [parent-id]="selClientTest?.ID"
        [disabled]="!selClientTest"
        (valueChange)="processPresetValue($event)"></input-search>
    </div>

    <div class="mt-2">
      <label>Regular With Provider</label>
      <input-search
        [provider]="userProvider"
        [regular]="true"
        (valueChange)="processPresetValue($event)"></input-search>
    </div>

    <div class="mt-2">
      <label>Regular Without Provider(Preset Values)</label>
      <input-search
        [preset]="stateItems"
        [regular]="true"
        (valueChange)="processPresetValue($event)"></input-search>
    </div>

    <div class="mt-2">
      <label>Multiple Input Search</label>
      <input-search [provider]="userProvider" [multiple]="true" (valueChange)="processPresetValue($event)">
      </input-search>
    </div>

    </div>

    <div class="col">
        <div class="mt-2">
      <label>Input Number</label>
      <input-data id="1" [minLength]="5" [maxLength]="10" fieldName="test" [type]="typeOfInput.NUMBER" [(ngModel)]="inputNumber" [provider]="userProvider"></input-data>
    </div>

    <div class="mt-2">
      <label>Input Text</label>
      <input-data id="1" [email]="true" fieldName="test"  [type]="typeOfInput.TEXT" [(ngModel)]="inputValue" [provider]="userProvider"></input-data>
    </div>

    <div class="mt-2">
      <label>Input Money</label>
      <input-data id="2" fieldName="test" [type]="typeOfInput.MONEY" [(ngModel)]="myMoney"
        [provider]="clientProvider"></input-data>
    </div>

    <div class="mt-2">
      <label>Input Label</label>
      <input-label id="2" fieldName="test" [type]="typeOfInput.TEXT" [(ngModel)]="myLabel"
        [provider]="clientProvider" placeholder="Test Label"></input-label>
    </div>
    </div>
  </div>
  <!-- <form #form="ngForm" novalidate>-->



  <!-- </form> -->

</div>


